module.exports = __webpack_public_path__ + "img/inter_3.45e51def.gif";